export default "__VITE_ASSET__Blg1e9f8__"